import React, { Component } from "react";
import swal from "@sweetalert/with-react";
import ReactRoundedImage from "react-rounded-image";
import {
  Col,
  Row,
  Container,
  FormGroup,
  Input,
  Label,
  InputGroupAddon,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { baseurl } from "../../baseurl.js";
import { headers, companyId, username, token } from "../../utils/variables";
import { Redirect } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Responseloader from "./ShortCutComponents/ResponseLoader";
import "./purchasePrintscss.css";
import { check_Bussiness_Permission } from "../../Helper";

/*
 * Thousands-separated fixed-decimal formatter, replacing the repeated
 * `value?.toFixed(n).toString().replace(...)` chain.
 *
 * The optional chaining in that chain printed an empty cell whenever the value
 * was null or undefined, and on a document a blank and a zero are not the same
 * claim -- a reader cannot tell "nothing was issued" from "we failed to load
 * this". Quantities keep 3 decimals, money 2; the line and footer versions had
 * drifted apart (lines at 3, totals at 2) so the totals row disagreed with the
 * column it was summing.
 */
const printNum = (value, decimals) =>
  Number(value ?? 0)
    .toFixed(decimals)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

var thisContex;
var UserName = localStorage.getItem("firstName");
var companylog = localStorage.getItem("profile_pic");
var companyName = localStorage.getItem("companyName");
let companySym;

class PrintView extends Component {
  constructor(props) {
    super(props);

    let tempLogedIn = false;
    if (token != null) {
      tempLogedIn = true;
    }
    let propInvoiceId = this.props?.location?.state?.id || this.props?.id;
    let propHeaderPrefix = this.props?.location?.state?.headerPrefix || this.props?.headerPrefix;
    // let propInvoiceId = 33;
    propInvoiceId = propInvoiceId ? propInvoiceId : -1;
    console.log("this.prop", this.props);
    console.log("this.prop", propHeaderPrefix);
    //////////////-------Components this States here to use in only Class Components ------///////////////////////
    this.state = {
      logInStatus: tempLogedIn,
      invoiceNo: "",
      poNumber: "",
      productionNo: "",
      issueDate: "",
      dueDate: "",
      companyName: companyName,
      clientName: "",
      viYearMake: "",
      zipCode: "",
      viModel: "",
      licenseNo: "",
      ExpenseDesc: "",
      vehicleIdNo: "",
      viMileage: "",
      city: "",
      tireFee: "",
      state: "",
      loadingResponce: false,
      setNextPrintPageFooter: false,
      setFooterData: [],
      labour: "",
      TireFee: "",
      TireDispossal: "",
      headerPrefix: propHeaderPrefix ? propHeaderPrefix : "",
      total_fet: 0,
      zip: "",
      disTotalItems: -1,
      sub_Amount_total_items: -1,
      total_Amount: -1,
      total_qty: 0,
      total_req_qty: 0, 
      invoiceId: propInvoiceId,
      downloadLink: null,
      showPopup: false,
      inputValue: "",
      inputEmail: "",
      actionType: "",
      isCrumble: false,
      isEgg: false,
      passwordType: "password",
    };
    thisContex = this;
    companySym = `${baseurl}/getImages/labelCard/?fileName=${companylog}`;
  }

  checkBussinessPermission = async () => {
    try {
      let checkBussinessPermission = await check_Bussiness_Permission();
      console.log("checkBussinessPermission :>> ", checkBussinessPermission);

      let {
        business_type_id,
        isCrumble,
        isAgh,
        isDollarjnction,
        isEggSpectation,
      } = checkBussinessPermission;

      if (isCrumble) {
        this.setState({ isCrumble: true }, () => {
          console.log("Updated isCrumble:", this.state.isCrumble , this.state.invoiceId);

          if (this.state.invoiceId !== -1) {
            this.getitemValidation(this.state.invoiceId);
          } else {
            this.getPrintCall();
          }
        });
      } else if (isEggSpectation) {
        this.setState({ isEgg: true }, () => {
          console.log("Updated isEggSpectation:", this.state.isEgg);
          this.getPrintCall();
        });
      } else {
        this.getPrintCall();
      }
    } catch (error) {
      console.error("Error in checkBussinessPermission:", error);
    }
  };

  async componentDidMount() {
    await this.checkBussinessPermission();
  }
  getitemValidation(invoiceId) {
    this.setState({ loadingResponce: true });

    axios
      .post(
        `${baseurl}/issueNote/getItemValidations`,
        { id: invoiceId, username: username },
        { headers: { authorization: token } },
      )
      .then((response) => {
        const data = response.data?.data || [];
        console.log("Validation Data:", data[0]);
        console.log("is_fg_sub_inv_11 value:", data[0]?.is_fg_sub_inv_11);
        if (data[0]?.is_fg_sub_inv_11 === 1) {
          console.log("Validation failed: branch found, opening popup.");
          this.openPopup();
        } else {
          // alert("Validation successful.");
          this.getPrintCall();
        }
      })
      .catch((err) => {
        console.error("Error in getItemValidations", err);
      })
      .finally(() => {
        this.setState({ loadingResponce: false });
      });
  }

  openPopup = () => {
    this.setState({
      showPopup: true,
      inputValue: "",
    });
  };
  renderPopup = () => {
    return (
      <div className="modal-backdrop">
        <div className="popup-box">
          <label className="float-left">Enter Email:</label>
          <input
            type="email"
            value={this.state.inputEmail || ""}
            onChange={(e) => this.setState({ inputEmail: e.target.value })}
            className="form-control mb-2"
          />

          <label className="float-left">Enter Validation Code:</label>
          {/* <input
            type="password"
            value={this.state.inputValue}
            onChange={(e) => this.setState({ inputValue: e.target.value })}
            className="form-control mb-3"
          /> */}

          <InputGroup className="mb-2">
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="icon-lock"></i>
              </InputGroupText>
            </InputGroupAddon>

            <Input
              type={this.state.passwordType}
              name="password"
              autoComplete="new-password"
              value={this.state.inputValue}
              onChange={(e) => this.setState({ inputValue: e.target.value })}
            />
            <InputGroupAddon addonType="prepend">
              <InputGroupText
                onClick={() => {
                  this.setState({
                    passwordType:
                      this.state.passwordType === "password"
                        ? "text"
                        : "password",
                  });
                }}
                style={{ cursor: "pointer" }}
              >
                {this.state.passwordType === "password" ? (
                  <i className="fa fa-eye-slash"></i>
                ) : (
                  <i className="fa fa-eye"></i>
                )}
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>

          <button
            type="button"
            className="btn btn-success mx-1"
            onClick={() => this.handleValidation()}
          >
            Go
          </button>
          <button
            type="button"
            className="btn btn-secondary mx-1"
            onClick={() => this.handleCancel()}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  };
  handleCancel = () => {
    this.setState({ showPopup: false, inputValue: "" });
    this.props.history.push({
      pathname: this.state.goBackUrl,
    });
  };
  handleValidation = () => {
    const { inputValue } = this.state;
    const token = localStorage.getItem("token");

    axios
      .post(
        `${baseurl}/lovs/specialAuthorization`,
        {
          verifCode: inputValue,
          verifEm: this.state.inputEmail,
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        },
      )
      .then((response) => {
        if (response.data.valid) {
          // this.getLovsLoad();
          this.getPrintCall();
        } else {
          swal({
            title: "Validation Failed",
            text: "Invalid validation code or email.",
            icon: "error",
          });
          this.handleCancel();
        }
        this.setState({ showPopup: false, inputValue: "" });
      })
      .catch((error) => {
        console.error("Validation error:", error);
        swal({
          title: "Validation Failed",
          text: "Invalid validation code or email.",
          icon: "error",
        });
        this.setState({ showPopup: false });
      });
  };

  downloadInvoice() {
    const element = document.getElementById("pdfContent");
  }

  convertToCurrency(param_number) {
    return param_number !== 0 && param_number !== null && param_number > 0
      ? Number(
          param_number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        )?.toFixed(2)
      : 0;
  }
  getFooterDataWithId = (id) => {
    thisContex.setState({ loadingResponce: true });
    return axios
      .post(
        `${baseurl}/masterData/getDocFooterSetupId`,
        { id, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        },
      )

      .then((res) => {
        thisContex.setState({ loadingResponce: true });

        let response = res.data.data[0];
        console.log("hhhhh", response);
        let label;
        if (response.page_size === "F") {
          label = "Full";
        } else {
          label = "Half";
        }
        const formValuesFooterData = [];

        if (response.desc1 !== null) {
          formValuesFooterData.push({
            desc: response.desc1,
            enteredBy: response.Ent_by_1,
          });
        }
        if (response.desc_2 !== null) {
          formValuesFooterData.push({
            desc: response.desc_2,
            enteredBy: response.Ent_by_2,
          });
        }
        if (response.desc_3 !== null) {
          formValuesFooterData.push({
            desc: response.desc_3,
            enteredBy: response.Ent_by_3,
          });
        }
        if (response.desc_4 !== null) {
          formValuesFooterData.push({
            desc: response.desc_4,
            enteredBy: response.Ent_by_4,
          });
        }
        if (response.desc_5 !== null) {
          formValuesFooterData.push({
            desc: response.desc_5,
            enteredBy: response.Ent_by_5,
          });
        }
        if (response.desc_6 !== null) {
          formValuesFooterData.push({
            desc: response.desc_6,
            enteredBy: response.Ent_by_6,
          });
        }
        console.log("hhhhh>", formValuesFooterData);
        if (formValuesFooterData.length > 3) {
          thisContex.setState({ setNextPrintPageFooter: true });
        } else {
          thisContex.setState({ setNextPrintPageFooter: false });
        }
        thisContex.setState({ setFooterData: formValuesFooterData });
        return formValuesFooterData.length;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        thisContex.setState({ loadingResponce: false });
      });
  };
  getPrintCall() {
    let invLable;
    axios
      .post(`${baseurl}/auth/getCompany`, {
        username: username,
      })
      .then((response) => {
        var data = response.data.data;

        for (let index = 0; index < data.length; index++) {
          if (data[index]?.COMPANY_ID == companyId)
            invLable = data[index]?.LABEL;
        }
        console.log("invLable......", invLable, companylog);
        // companySym = `${baseurl}/getImages/labelCard/?fileName=${invLable}`;
      })
      .catch((error) => {
        console.log(error);
      });
    const { state } = this.props?.location || {} ;

    // let invoiceId = 7;
    if (this.state.invoiceId !== -1) {
      thisContex.setState({ loadingResponce: true });

      //   if (state?.printType === "Purchase") {
      // let endPoint =
      //   state?.headerPrefix === "Purchase Order"
      //     ? "getPrintPurchaseOrderView"
      //     : state?.headerPrefix === "CREATE GOODS RECEIPT NOTE"
      //     ? "getGrnPrintView"
      //     : state?.headerPrefix === "Sale" ||
      //       state?.headerPrefix === "Sale Return"
      //     ? "getSalesPrint"
      //     : state?.headerPrefix === "Sale Order"
      //     ? "getSalesOrderPrint"
      //     : "getPrintPurchaseView";
      axios
        .post(
          `${baseurl}/masterData/getIssuePrintView`,
          {
            username,
            invoiceId: this.state?.invoiceId,
            companyId,
          },
          headers,
        )
        .then(function (response) {
          let res_mt = response.data.data[0];
          let res_det = response.data.data1;
          // No reverse: the query now returns the lines ordered by sr_no. It
          // previously had no ORDER BY, so this flipped an order that was
          // arbitrary to begin with.
          let total_Amount = 0;
          let total_qty = 0;
          let total_req_qty = 0; 
          let discount = 0;
          let invoiceNo = res_mt?.["DOCUMENT_NO"];
          let invBookId = res_mt?.["INV_BOOK_ID"];
          let poNumber = res_mt?.["INVOICE_REF_NO"];
          let productionNo = res_mt?.["production_no"];
          let issueDate = res_mt?.["issueDate"];
          let dueDate = res_mt?.["dueDate"];
          let mtRemarks = res_mt?.["mtRemarks"];
          let remarks = res_mt?.["REMARKS"];
          let Item_Desc_Lov = res_det[0]?.["Item_Desc_Lov"];
          let company_no = res_mt?.["company_no"];
          let specificMsg = res_mt?.["trans_type"]
            ? res_mt?.["trans_type"]
            : "";
          let preparedBy = res_mt?.["created_by_name"];
          let dem_issue_no = res_mt?.["dem_issue_no"];
          let fromBranch = res_mt?.["from_branch"];
          let toBranch = res_mt?.["to_branch"];

          for (let index = 0; index < res_det.length; index++) {
            total_Amount += res_det[index].Item_amount;
            total_qty += res_det[index].item_qty;
            total_req_qty += res_det[index].req_item_qty; 
          }

          thisContex.getFooterDataWithId(res_mt?.["INV_BOOK_ID"]);

          thisContex.setState({
            loadingResponce: false,
            invoiceNo: invoiceNo,
            poNumber: poNumber,
            productionNo: productionNo,
            mtRemarks: mtRemarks,
            issueDate: moment(issueDate).format("DD-MMM-YY"),
            res_det: res_det,
            Item_Desc_Lov,
            total_Amount: total_Amount,
            total_qty: total_qty,
            total_req_qty: total_req_qty,
            company_no,
            invBookId,
            specificMsg,
            state,
            preparedBy: preparedBy,
            dem_issue_no: dem_issue_no,
            fromBranch,
            toBranch,
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
  goBackToInvoice() {
    this.setState({
      goBack: true,
    });
  }

  render() {
    const {
      invoiceId,
      logInStatus,
      invoiceNo,
      poNumber,
      productionNo,
      dem_issue_no,
      issueDate,
      mtRemarks,
      companyName,
      total_Amount,
      total_qty,
      total_req_qty,
      Item_Desc_Lov,
      goBack,
      headerPrefix,
      fromBranch,
      toBranch,
      loadingResponce,
      specificMsg,
      preparedBy,
    } = this.state;
    if (!logInStatus) return <Redirect to="/login" />;
    else if (loadingResponce) {
      return <Responseloader />;
    } else if (goBack) {
      return (
        <Redirect
          push
          to={{
            pathname: this.props.location.state?.url,
            state: {
              id: this.state.invoiceId,
              updateCheck: this.props.location.state?.updateCheck, //AHMAD
              // updateCheck: 2, //AHMAD
            },
          }}
        />
      );
    } else if (invoiceId !== -1) {
      return (
        <div className="pdfContent-Print" id="pdfContent-Print">
          {this.state.showPopup && this.renderPopup()}{" "}
          <Row
            className="app-body-Invoice-Print bg-white"
            style={{ overFlow: "hidden" }}
          >
            <Col xs="12">
              <Row className="">
                <Col xs="4" className="px-5 row">
                  <ReactRoundedImage
                    className="ReactRoundedImage"
                    image={companySym}
                    roundedColor="#321124"
                    imageWidth="50"
                    imageHeight="45"
                    roundedSize="4"
                  />
                  <h1 className="ml-1">{companyName}</h1>
                </Col>
                <Col xs="5">
                  {"  "}
                  <h2 className="text-center">
                    <u>{headerPrefix}</u>
                  </h2>{" "}
                </Col>
                <Col xs="3" className="px-4">
                  <div style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary mx-2"
                      id="printPageButton"
                      onClick={() => {
                        window.print();
                      }}
                    >
                      Print to PDF!
                    </button>
                    <button
                      className="btn btn-primary m-1"
                      id="printPageButton"
                      onClick={() => {
                        this.goBackToInvoice();
                      }}
                    >
                      Back
                    </button>
                  </div>{" "}
                </Col>
              </Row>
              <br></br>
              <hr
                style={{
                  marginTop: "-0.7rem",
                  border: "1px solid Light gray",
                }}
              />
              <Row className="px-4 display-flex flex">
                <Col
                  xs="6"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginTop: "2%",
                    marginBottom: "2%",
                  }}
                >
                  {/*
                    * Which branch the stock left and which it went to. Rendered
                    * only when present: to_sub_inv_id is null on a return
                    * raised against an issue, and showing "To: " with nothing
                    * after it reads as missing data rather than as a document
                    * that never had one.
                    */}
                  {fromBranch && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        From Branch:
                      </h4>
                      <span style={{ marginLeft: "10px" }}>
                        <h5>{fromBranch}</h5>
                      </span>
                    </div>
                  )}
                  {toBranch && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        To Branch:
                      </h4>
                      <span style={{ marginLeft: "10px" }}>
                        <h5>{toBranch}</h5>
                      </span>
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      Remarks:
                    </h4>
                    <span style={{ marginLeft: "10px" }}>
                      <h5>{mtRemarks}</h5>
                    </span>
                  </div>
                </Col>
                {/*
                  * Second half of the header row, laid out by the grid.
                  *
                  * This was positioned with marginLeft: "76%" and
                  * marginTop: "-5.5%" -- percentages of the parent width, which
                  * shift with paper size and print scale, and pull the block up
                  * over the Remarks beside it once the remarks run to more than
                  * one line. Two xs="6" columns in a Row already sit side by
                  * side; the negative offsets were fighting the grid rather
                  * than using it.
                  */}
                <Col
                  xs="6"
                  className="px-4"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginTop: "2%",
                    marginBottom: "2%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      {specificMsg ? specificMsg : ""} No:
                    </h4>
                    <span style={{ marginLeft: "3px" }}>
                      <h5>{invoiceNo}</h5>
                    </span>
                  </div>

                  {poNumber && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        PO Number:
                      </h4>
                      <span style={{ marginLeft: "0px" }}>
                        <h5>{poNumber}</h5>
                      </span>
                    </div>
                  )}

                  {productionNo && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Production No:
                      </h4>
                      <span style={{ marginLeft: "0px" }}>
                        <h5>{productionNo}</h5>
                      </span>
                    </div>
                  )}
                  {dem_issue_no && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        Dem.Issue No:
                      </h4>
                      <span style={{ marginLeft: "0px" }}>
                        <h5>{dem_issue_no}</h5>
                      </span>
                    </div>
                  )}

                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      Issue Date:
                    </h4>
                    <span style={{ marginLeft: "4px" }}>
                      <h5>{issueDate}</h5>
                    </span>
                  </div>
                </Col>
              </Row>
              <div className="col-md-12">
                <hr
                  style={{
                    border: "1px solid Light gray",
                  }}
                />
              </div>
              <Row xs="12" className="px-1">
                <Col xs="12">
                  <table
                    className="table table-bordered issue-print-table"
                    style={{ width: "100%" }}
                  >
                    <colgroup>
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "20%" }} />
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "30%" }} />
                      {!this.state.isEgg && <col style={{ width: "10%" }} />}
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "10%" }} />
                    </colgroup>

                    <thead>
                      <tr>
                        <th>Sr</th>
                        {Item_Desc_Lov ? <th>Item</th> : <th>Item</th>}
                        <th>Unit</th>
                        <th className="">Cost Center</th>
                        {!this.state.isEgg && (
                          <th className="text-right">Req. Qty</th>
                        )}
                        <th className="text-right">{specificMsg} Qty</th>
                        <th className="text-right">Rate</th>
                        <th className="text-right">Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {this.state.res_det?.map((itm, index) => {
                        return (
                          <tr key={index}>
                            {/* The document's own line number, so the print
                                agrees with the form rather than renumbering
                                whatever order the rows arrived in. */}
                            <td>{itm.sr_no ?? index + 1}</td>
                            <td>
                              {itm.item_desc} {itm.item_code}
                            </td>
                            <td>
                              {itm.item_unit && itm.item_unit !== "undefined"
                                ? itm.item_unit.toString()
                                : ""}
                            </td>
                            <td className="">{itm.cost_center}</td>

                            {!this.state.isEgg && (
                              <td className="text-right">
                                {printNum(itm.req_item_qty, 3)}
                              </td>
                            )}

                            <td className="text-right">
                              {printNum(itm.item_qty, 3)}
                            </td>
                            <td className="text-right">
                              {printNum(itm.item_rate, 3)}
                            </td>
                            <td className="text-right">
                              {printNum(itm.Item_amount, 2)}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>

                    <tfoot>
                      <tr>
                        <td
                          colSpan={4}
                          style={{ textAlign: "right" }}
                        >
                          <b>Total (PKR)</b>
                        </td>
                        {!this.state.isEgg && (
                          <td className="text-right">
                            <b>{printNum(total_req_qty, 3)}</b>
                          </td>
                        )}
                        <td className="text-right">
                          <b>{printNum(total_qty, 3)}</b>
                        </td>
                        <td className="text-right">
                          <b></b>
                        </td>
                        <td className="text-right">
                          <b>{printNum(total_Amount, 2)}</b>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </Col>
              </Row>
            </Col>
            <Container
              className="footerPrint"
              style={{ backgroundColor: "white" }}
            >
              <Row
                className="footerRows mt-5"
                style={{
                  textAlign: "center",
                }}
              >
                {this.state.setFooterData.map((row, index) => (
                  <Col
                    key={index}
                    lg="4"
                    md="4"
                    sm="4"
                    className="px-4"
                    style={{
                      marginBottom: "3rem",
                      marginTop: row.enteredBy != 1 ? "1.3rem" : "0",
                    }}
                  >
                    <h5>
                      {index === 0 && !row.enteredBy
                        ? preparedBy
                        : row.enteredBy}
                    </h5>
                    <hr
                      style={{
                        border: "1px solid ",
                        borderColor: "E4E5E6",
                        margin: "revert",
                      }}
                    />
                    <h4 key={row.id}>{row.desc}</h4>
                  </Col>
                ))}
              </Row>
            </Container>
          </Row>
        </div>
      );
    } else {
      return (
        <div>
          <Row className="app-body-Invoice">
            <Col>
              <div
                className="col-md-12"
                style={{ width: "1100px", margin: "0 auto" }}
              >
                <div className="col-md-9">
                  <div className="row">
                    <div className="col-md-12">
                      <h2 style={{ fontWeight: "bold" }}>
                        <Redirect to="/IssueNoteOverview" />
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      );
    }
  }
}

export default PrintView;